import { Route, Routes } from 'react-router-dom';

import { SidebarLayout } from '../layouts/SidebarLayout';
import { NotFound } from '../pages/errors/NotFound';
import PatientApprove from '../pages/patient/Actions/PatientApprove';
import PatientDeliver from '../pages/patient/Actions/PatientDeliver';
import PatientDeliverRetainers from '../pages/patient/Actions/PatientDeliverRetainers';
import PatientRefinementApproval from '../pages/patient/Actions/PatientRefinementApproval';
import PatientReviewRefinement from '../pages/patient/Actions/PatientReviewRefinement';
import PatientReviewRetention from '../pages/patient/Actions/PatientReviewRetention';
import PatientRedirect from '../pages/patient/PatientRedirect';
import PatientOverview from '../pages/patient/Actions/PatientOverview';
import { ClientRoute } from './clientRoute';

export const PatientActionRoutes = () => {
    return (
        <Routes>
            {/* Patient Actions Routes */}
            <Route
                path=":id/overview"
                element={
                    <ClientRoute>
                        <SidebarLayout noScroll forceCollapsed>
                            <PatientOverview />
                        </SidebarLayout>
                    </ClientRoute>
                }
            />
            <Route
                path=":id/approve"
                element={
                    <ClientRoute>
                        <SidebarLayout noScroll forceCollapsed>
                            <PatientApprove />
                        </SidebarLayout>
                    </ClientRoute>
                }
            />
            <Route
                path=":id/deliver"
                element={
                    <ClientRoute>
                        <SidebarLayout noScroll forceCollapsed>
                            <PatientDeliver />
                        </SidebarLayout>
                    </ClientRoute>
                }
            />
            <Route
                path=":id/deliver-refinement"
                element={
                    <ClientRoute>
                        <SidebarLayout noScroll forceCollapsed>
                            <PatientDeliver variant="refinement" />
                        </SidebarLayout>
                    </ClientRoute>
                }
            />
            <Route
                path=":id/approve-refinement"
                element={
                    <ClientRoute>
                        <SidebarLayout noScroll forceCollapsed>
                            <PatientRefinementApproval />
                        </SidebarLayout>
                    </ClientRoute>
                }
            />
            <Route
                path=":id/deliver-retainers"
                element={
                    <ClientRoute>
                        <SidebarLayout noScroll forceCollapsed>
                            <PatientDeliverRetainers />
                        </SidebarLayout>
                    </ClientRoute>
                }
            />
            <Route
                path=":id/review-refinement"
                element={
                    <ClientRoute>
                        <SidebarLayout noScroll forceCollapsed>
                            <PatientReviewRefinement />
                        </SidebarLayout>
                    </ClientRoute>
                }
            />
            <Route
                path=":id/review-retention"
                element={
                    <ClientRoute>
                        <SidebarLayout noScroll forceCollapsed>
                            <PatientReviewRetention />
                        </SidebarLayout>
                    </ClientRoute>
                }
            />

            {/* Smart redirect based on patient status */}
            <Route
                path=":id"
                element={
                    <ClientRoute>
                        <PatientRedirect />
                    </ClientRoute>
                }
            />

            {/* 404 - Catch all unmatched routes */}
            <Route path="*" element={<NotFound />} />
        </Routes>
    );
};
